import React from 'react';

import clsx from 'clsx';

import styles from './List.module.scss';

export interface ListItem {
  message?: string;
  messageClassName?: string;
  listItemClassName?: string;
}

export interface ListProps {
  items: ListItem[];
}

const List = ({ items }: ListProps) => {
  return (
    <>
      {items.map((item, index) => {
        return (
          <li className={clsx(styles.listItem, item.listItemClassName)} key={index}>
            <span className={clsx(styles.listItemLabel, item.messageClassName)}>{item.message}</span>
          </li>
        );
      })}
    </>
  );
};

export default List;
